import { useEffect, useState } from 'react';

export default function useOnline(callback?: () => void) {
    const [online, setOnline] = useState(navigator?.onLine || false);

    useEffect(() => {
        const handleOnline = () => {
            callback?.()
            setOnline(true);
        };

        const handleOffline = () => {
            setOnline(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        }
    }, []);

    return online;
}